import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	const title = node.title;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)

	return {
		"id": id,
		"elements": [{
			"type": "shape",
			"id": "q4yMvkRhnC",
			"width": 336.15,
			"height": 289.78,
			"left": 595.22,
			"top": -146.02,
			"viewBox": [
				336.15,
				289.78
			],
			"path": "M 168.075 0 L 0 289.78 L 336.15 289.78 Z",
			"fill": "rgba(255,255,255,1)",
			"fixedRatio": false,
			"rotate": 266,
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial Narrow;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "rgba(244,244,244,1)",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false,
			"shadow": {
				"h": 4,
				"v": 7,
				"blur": 10,
				"color": "rgba(129,126,126,1)"
			},
			"pathFormula": "triangle",
			"keypoint": 0.5,
			"opacity": 0.9
		},
		{
			"type": "shape",
			"id": "pOB717d4Kj",
			"width": 251.18,
			"height": 216.53,
			"left": -125.59,
			"top": -7.26,
			"viewBox": [
				251.18,
				216.53
			],
			"path": "M 125.59 0 L 0 216.53 L 251.18 216.53 Z",
			"fill": "rgba(255,255,255,1)",
			"fixedRatio": false,
			"rotate": 325,
			"outline": {
				"color": "#5B9BD5",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial Narrow;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "rgba(244,244,244,1)",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false,
			"shadow": {
				"h": 0.1,
				"v": 1.88,
				"blur": 38.54,
				"color": "rgb(196, 196, 196)"
			},
			"pathFormula": "triangle",
			"keypoint": 0.5
		},
		{
			"type": "shape",
			"id": "3h2ZmPBILg",
			"width": 283.7,
			"height": 244.57,
			"left": 737.08,
			"top": 341.57,
			"viewBox": [
				283.7,
				244.57
			],
			"path": "M 141.85 0 L 0 244.57 L 283.7 244.57 Z",
			"fill": "rgba(255,255,255,1)",
			"fixedRatio": false,
			"rotate": 289,
			"outline": {
				"color": "#5B9BD5",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial Narrow;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "rgba(244,244,244,1)",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false,
			"shadow": {
				"h": -10,
				"v": -5,
				"blur": 6,
				"color": "rgb(196, 196, 196)"
			},
			"pathFormula": "triangle",
			"keypoint": 0.5
		},
		{
			"type": "shape",
			"id": "DVYf5GiapT",
			"width": 336.15,
			"height": 289.78,
			"left": -56.1,
			"top": 428.42,
			"viewBox": [
				336.15,
				289.78
			],
			"path": "M 168.075 0 L 0 289.78 L 336.15 289.78 Z",
			"fill": "rgba(255,255,255,1)",
			"fixedRatio": false,
			"rotate": 169,
			"outline": {
				"color": "#5B9BD5",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial Narrow;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "rgba(244,244,244,1)",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false,
			"shadow": {
				"h": 0.1,
				"v": 1.88,
				"blur": 11,
				"color": "rgb(196, 196, 196)"
			},
			"pathFormula": "triangle",
			"keypoint": 0.5
		},
		{
			"type": "text",
			"id": "rZJdI013YQ",
			"width": 421.74,
			"height": 40.046875,
			"left": 272.90451220813463,
			"top": 358.96494049235514,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "rgba(127,127,127,1)",
			"content": "<p style=\"text-align: center;\"><span style=\"font-size: 19.05px;\"><span style=\"font-family: Arial Narrow;\"><span style=\"color: rgba(161,155,155,1);\">部门：设计部&nbsp;&nbsp;汇报人：ChatGpt</span></span></span></p>",
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		},
		{
			"type": "shape",
			"id": "-RsJP2ZwVj",
			"width": 251.18,
			"height": 216.53,
			"left": 174.7,
			"top": -188.56,
			"viewBox": [
				251.18,
				216.53
			],
			"path": "M 125.59 0 L 0 216.53 L 251.18 216.53 Z",
			"fill": "rgba(255,255,255,1)",
			"fixedRatio": false,
			"rotate": 39,
			"outline": {
				"color": "#5B9BD5",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial Narrow;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "rgba(244,244,244,1)",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false,
			"shadow": {
				"h": 0.1,
				"v": 1.88,
				"blur": 14,
				"color": "rgb(196, 196, 196)"
			},
			"pathFormula": "triangle",
			"keypoint": 0.5
		},
		{
			"type": "shape",
			"id": "Q0V6LO71r1",
			"width": 49.14,
			"height": 42.37,
			"left": 372.36,
			"top": 454.93,
			"viewBox": [
				49.14,
				42.37
			],
			"path": "M 24.57 0 L 0 42.37 L 49.14 42.37 Z",
			"fill": "rgba(255,255,255,1)",
			"fixedRatio": false,
			"rotate": 39,
			"outline": {
				"color": "#5B9BD5",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial Narrow;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "rgba(244,244,244,1)",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false,
			"shadow": {
				"h": 0.1,
				"v": 1.88,
				"blur": 38.54,
				"color": "rgb(150, 150, 150)"
			},
			"pathFormula": "triangle",
			"keypoint": 0.5
		},
		{
			"type": "shape",
			"id": "eWlLJnQdVk",
			"width": 280.2,
			"height": 146.42,
			"left": 359.9,
			"top": 96.03,
			"viewBox": [
				200,
				200
			],
			"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
			"fill": "rgba(255,255,255,1)",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"flipH": false,
			"flipV": false,
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 88px;\"><span style=\"color: rgba(127,127,127,1);\">20XX</span></span></p>",
				"defaultFontName": "微软雅黑",
				"defaultColor": "#000",
				"align": "middle"
			}
		},
		{
			"type": "shape",
			"id": "bp_4j0Mspo",
			"width": 575.2693160572713,
			"height": 116.28409892320435,
			"left": 220.64838539817774,
			"top": 223.10795053839783,
			"viewBox": [
				200,
				200
			],
			"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
			"fill": "rgba(255,255,255,1)",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 54px;\"><span style=\"font-family: +mn-lt;\"><span style=\"color: rgba(127,127,127,1);\"><sub>${title}</sub></span></span></span></p>`,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "rgba(244,244,244,1)",
				"align": "top"
			},
			"flipH": false,
			"flipV": false
		}],
		background
	};

}